import { Div, Label, Loader } from "@grassrootly/rn-core";
import { ScrollView, RefreshControl } from "react-native";
import moment from "moment";
import { useCompetitionMatches } from "./useCompetitionMatches";
import { GamesListItem } from "../../components/game/games-list";
import { MainStackScreenProps } from "../../navigation/Navigation.types";

interface CompetitionMatchesTabProps {
  competitionId: number;
  seasonId: number;
  navigation: MainStackScreenProps<"competition-detail">["navigation"];
}

export default function CompetitionMatchesTab({ competitionId, seasonId, navigation }: CompetitionMatchesTabProps) {
  const { matches, loading, refreshMatches } = useCompetitionMatches(competitionId, seasonId);

  const onMatchPress = (gameId: number) => {
    navigation?.navigate("game", { id: gameId });
  };

  // Sort matches by date descending (latest first)
  const sortedMatches = matches
    .slice()
    .sort((a, b) => moment(b.game_datetime).diff(moment(a.game_datetime)));

  return (
    <Div classNames={["flex1"]}>
      {loading && !matches?.length ? (
        <Div classNames={["mt-{30}"]}>
          <Loader size="large" isLoading />
        </Div>
      ) : null}

      {!loading && matches && !matches.length ? (
        <Div classNames={["flex1", "alignItemsCenter", "justifyContentCenter", "mt-{30}"]}>
          <Label type="l1Bold" classNames={["textCenter", "colorSecondaryLight"]}>
            No matches scheduled for this season
          </Label>
        </Div>
      ) : null}

      <ScrollView refreshControl={<RefreshControl refreshing={loading} onRefresh={refreshMatches} />}>
        {sortedMatches.map((match) => (
          <GamesListItem
            key={match.game_id}
            game={match as any}
            onGamePress={() => onMatchPress(match.game_id)}
          />
        ))}
      </ScrollView>
    </Div>
  );
}
